<script>
  import { fmtNum, fmtPct } from '../utils/format.js';

  /**
   * Tabular breakdown of the top parties — pill | name | % | (votes).
   * Adds an "Otros" row when the top N doesn't add up to ~100%.
   */
  let { topParties = [], partyColor, partyLongName } = $props();

  const hasVotes = $derived(topParties.some((p) => p.votes != null));
  const sumPct = $derived(topParties.reduce((s, p) => s + (p.pct || 0), 0));
  const otherPct = $derived(
    sumPct > 0 && sumPct < 99.9 ? Math.max(0, 100 - sumPct) : null
  );
</script>

<div class="tooltip-body">
  <table>
    <thead>
      <tr>
        <th></th>
        <th></th>
        <th>% Voto</th>
        {#if hasVotes}<th>Votos</th>{/if}
      </tr>
    </thead>
    <tbody>
      {#each topParties as p, i (p.name + i)}
        <tr class={'row-' + p.name}>
          <td class="pill-item">
            <span style:background={partyColor(p.name, p.code)}></span>
          </td>
          <td title={partyLongName(p.name)}>{p.name || '—'}</td>
          <td>{fmtPct(p.pct, 2, false)}</td>
          {#if hasVotes}
            <td>{p.votes != null ? fmtNum(p.votes) : '—'}</td>
          {/if}
        </tr>
      {/each}
      {#if otherPct != null}
        <tr class="row-others">
          <td class="pill-item"><span></span></td>
          <td>Otros</td>
          <td>{fmtPct(otherPct, 2, false)}</td>
          {#if hasVotes}<td>—</td>{/if}
        </tr>
      {/if}
    </tbody>
  </table>
</div>
